import type { FC } from "react";
import { Illustration, type IllustrationProps } from "@huub-web/shared";
import type {
  ThemeScope,
  ThemeSlotPropsMap,
} from "@huub-web/ui/contexts/ThemeSlotContext";

const ILLUSTRATION_MAP: Partial<Record<ThemeScope, IllustrationProps["name"]>> =
  {
    maximumMortgage: "calculate",
    orientation: "houseAnalysis",
    financialProfile: "certificate",
    assessment: "certificate",
    advice: "certificate",
    interestRates: "interest",
    documentsOutgoing: "clipboard",
    documentsIncoming: "clipboard",
  };

/**
 * Huub (default light) per-scope visual — renders an Illustration. Shared by
 * the hub cards and the page heading via the `scopeVisual` slot, replacing the
 * previous per-card visual components.
 */
export const HuubScopeVisual: FC<ThemeSlotPropsMap["scopeVisual"]> = ({
  scope,
  size,
  alt = "",
}) => {
  const illustrationName = ILLUSTRATION_MAP[scope] ?? "default";
  const illustrationSize = size && size <= 72 ? "xs" : "s";

  return (
    <Illustration name={illustrationName} size={illustrationSize} alt={alt} />
  );
};
